<template>
  <section class="company" id="company">
    <!-- 背景图片层 -->
    <div class="company-bg">
      <img src="@/assets/building.png" alt="公司大楼">
    </div>
    
    <div class="container">
      <div class="company-text">
        <h2>中广互联科技（广州）有限公司</h2>
        <p>中广互联科技（广州）公司，2023年成立的科技创新企业，专注于以科技赋能教育，助力学生健康成长。其核心产品包括校园视频电话、AI心理健康与防欺凌系统，均旨在保障学生安全与健康。</p>
        <p>公司旗舰品牌"广校通"，融合大数据、AI、云计算技术，打造个性化学习与健康管理平台。广校通不仅促进家校沟通，更通过智能监测与分析，为学生提供健康与成长方案，包括饮食、运动建议，全面护航学生身心健康成长。</p>
        <p>秉持"科技护航成长"理念，广校通不断探索教育科技新边界，致力于为学生全面发展注入科技动力。</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CompanyIntro'
}
</script>

<style scoped>
.company {
  position: relative;
  padding: 80px 0;
  min-height: 750px;
  overflow: hidden;
}

.company-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
}

.company-bg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center right;
  display: block;
}

.container {
  position: relative;
  z-index: 1;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 60px;
}

.company-text {
  max-width: 650px;
}

/* 标题颜色加深 */
.company-text h2 {
  font-size: 36px;
  margin-bottom: 24px;
  color: #111827; /* 改为更深的近黑色 */
  font-weight: 700;
  line-height: 1.3;
}

/* 正文颜色加深 */
.company-text p {
  font-size: 15px;
  color: #374151; /* 改为更深的深灰色，提高对比度 */
  margin-bottom: 18px;
  line-height: 1.8;
  text-align: justify;
}

.company-text p:last-child {
  margin-bottom: 0;
}

/* 响应式 */
@media (max-width: 1024px) {
  .company-text {
    max-width: 80%;
  }
}

@media (max-width: 768px) {
  .company {
    padding: 60px 0;
    min-height: 400px;
  }
  
  .container {
    padding: 0 20px;
  }
  
  .company-text {
    max-width: 100%;
  }
  
  .company-text h2 {
    font-size: 28px;
  }
  
  .company-text p {
    font-size: 14px;
    line-height: 1.8;
  }
}
</style>